export const TAB_SOFTWARE_ID = 'software';
export const TAB_TOPICS_ID = 'topics';
export const TAB_MANUALS_ID = 'manuals';
export const TAB_VIDEOS_ID = 'videos';
